import {UPDATE_QUESTIONS_START} from "../../types";

export const update_questions = (payload) => ({
    type: UPDATE_QUESTIONS_START,
    payload,
});
